import createImageUrlBuilder from "@sanity/image-url";

// Hardcoded because image URL building runs client-side in the browser where
// Cloudflare Worker env bindings aren't available. These are public values
// (visible in every Sanity CDN URL) so there's no security concern.
const PROJECT_ID = "ormk23sc";
const DATASET = "production";

const imageBuilder = createImageUrlBuilder({
  projectId: PROJECT_ID,
  dataset: DATASET,
});

/**
 * Returns a chainable image URL builder for a Sanity image reference.
 * Usage: `urlForImage(article.coverImage)?.width(1200).height(630).url()`
 */
export function urlForImage(source: unknown) {
  if (!source) return undefined;
  return imageBuilder.image(source);
}
